<mat-form-field class="form-field" [formGroup]="group" [ngStyle]="field.styles?.formField" [color]="field.color">
  <mat-chip-list #chipList [ngStyle]="field.styles?.list" aria-label="options creator" >
    <mat-chip *ngFor="let option of options" [ngStyle]="field.styles?.option" [selectable]="true" [removable]="true"
      (removed)="remove(option)">
      {{option}}
      <mat-icon matChipRemove *ngIf="state == 'edit' && field.enabled !== false">cancel</mat-icon>
    </mat-chip>
    <input [placeholder]="field.options?.placeholder" [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="field.options.addOnBlur" (matChipInputTokenEnd)="add($event)">
  </mat-chip-list>
</mat-form-field>
